import * as React from 'react';
import { Messages } from '../../Services/Constants';
import { Link } from 'react-router-dom';

const messageStyle: React.CSSProperties = {
    padding: '100px',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    textAlign: 'center',
};
export function PageNotFound404(): React.ReactElement {
    return (
        <div style={messageStyle}>
            <h4>{Messages.PageNotFound}</h4>
            <p>{Messages.PageNotFoundMessage}</p>
            <Link to="/">Go back to Home</Link>
        </div>
    );
}

